import { Button, Checkbox, Form, Input } from 'antd';
import React, { useState } from 'react'
import { BASE_URL } from '../utils/routes';
import Cookies from 'js-cookie';
import { useNavigate } from 'react-router-dom';

const LoginForm = () => {
    const navigate = useNavigate();
    const [error, setError] = useState('');
    const [isSubmitting, setIsSubmitting] = useState(false);
    const onFinish = async (values) => {
      console.log('Success:', values);
      setIsSubmitting(true);
      try {
          const resLogin = await fetch(`${BASE_URL}wp-json/custom/v1/login`, {
              method: 'POST',
              headers: {
                  'Content-Type': 'application/json',
              },
              body: JSON.stringify({
                  login: values.email, // Directly use email here
                  password: values.password,
              }),
          });
  
          const data = await resLogin.json();
          console.log('data', data);
  
          if (data.token) {
              Cookies.set('token', data.token, { expires: 7 });
              navigate('/');
          } else {
              if (data.data && data.data.status === 403) {
                  setError('Invalid email or password');
              } else {
                  setError('Network error or invalid credentials');
              }
          }
      } catch (error) {
          console.error('Login failed:', error);
          setError('Network error occurred');
      } finally {
          setIsSubmitting(false);
      }
  };
  

      const onFinishFailed = (errorInfo) => {
        console.log('Failed:', errorInfo);
      };

  return (
    <Form
    name="basic"
    labelCol={{
      span: 8,
    }}
    wrapperCol={{
      span: 16,
    }}
    style={{
      maxWidth: 600,
    }}
    initialValues={{
      remember: true,
    }}
    onFinish={onFinish}
    onFinishFailed={onFinishFailed}
    autoComplete="off"
  >
    <Form.Item
      label="Email"
      name="email"
      rules={[
        {
          required: true,
          message: 'Please input your email!',
        },
      ]}
    >
      <Input />
    </Form.Item>

    <Form.Item
      label="Password"
      name="password"
      rules={[
        {
          required: true,
          message: 'Please input your password!',
        },
      ]}
    >
      <Input.Password />
    </Form.Item>
    
    {error && <p style={{ color:'red', textAlign: 'center' }}>{error}</p>}

    <Form.Item
      name="remember"
      valuePropName="checked"
      wrapperCol={{
        offset: 8,
        span: 16,
      }}
    >
      <Checkbox>Remember me</Checkbox>
    </Form.Item>

    <Form.Item
      wrapperCol={{
        offset: 8,
        span: 16,
      }}
    >
      <Button loading={isSubmitting} disabled={isSubmitting} type="primary" htmlType="submit">
        Submit
      </Button>
    </Form.Item>
  </Form>
  )
}

export default LoginForm;